export default "__VITE_ASSET__aaiEshq___"